// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VFY_","col":"styles_col__167sb","actions":"styles_actions__2pml9","conflict":"styles_conflict__7d3FZ"};